"use strict";

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var stream_1 = require("stream");
/**
 * An HTML parse listeners that detects <script> data blocks with known RDF media tyoes,
 * parses them, and outputs the resulting quads.
 */


var HtmlScriptListener =
/*#__PURE__*/
function () {
  function HtmlScriptListener(mediatorRdfParseHandle, cbQuad, cbError, cbEnd, supportedTypes, context, baseIRI) {
    _classCallCheck(this, HtmlScriptListener);

    this.handleMediaType = null;
    this.textChunks = null;
    this.endBarrier = 1;
    this.mediatorRdfParseHandle = mediatorRdfParseHandle;
    this.cbQuad = cbQuad;
    this.cbError = cbError;
    this.cbEnd = cbEnd;
    this.supportedTypes = supportedTypes;
    this.context = context;
    this.baseIRI = baseIRI;
  }

  _createClass(HtmlScriptListener, [{
    key: "onEnd",
    value: function onEnd() {
      if (--this.endBarrier === 0) {
        this.cbEnd();
      }
    }
  }, {
    key: "onTagClose",
    value: function onTagClose() {
      var _this = this;

      if (this.handleMediaType) {
        // Create a temporary text stream for pushing all the text chunks
        var textStream = new stream_1.Readable({
          objectMode: true
        });

        textStream._read = function () {
          return;
        };

        var textChunksLocal = this.textChunks; // Send all collected text to parser

        var parseAction = {
          context: this.context,
          handle: {
            baseIRI: this.baseIRI,
            input: textStream
          },
          handleMediaType: this.handleMediaType
        };
        this.mediatorRdfParseHandle.mediate(parseAction).then(function (_ref) {
          var handle = _ref.handle;
          // Initialize text parsing
          handle.quads.on('error', _this.cbError).on('data', _this.cbQuad).on('end', function () {
            return _this.onEnd();
          }); // Push the text stream after all events have been attached

          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = textChunksLocal[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var textChunk = _step.value;
              textStream.push(textChunk);
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }

          textStream.push(null);
        }); // Reset the media type and text stream

        this.handleMediaType = null;
        this.textChunks = null;
      }
    }
  }, {
    key: "onTagOpen",
    value: function onTagOpen(name, attributes) {
      // Only handle script tags with a parseable content type
      if (name === 'script' && this.supportedTypes[attributes.type]) {
        this.handleMediaType = attributes.type;
        this.textChunks = [];
        this.endBarrier++;
      } else {
        this.handleMediaType = null;
      }
    }
  }, {
    key: "onText",
    value: function onText(data) {
      if (this.handleMediaType) {
        this.textChunks.push(data);
      }
    }
  }]);

  return HtmlScriptListener;
}();

exports.HtmlScriptListener = HtmlScriptListener;